// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".staccato[data-v-116af266]{position:relative}.staccato[data-v-116af266]:before{background-color:#ffce22;border-radius:99px;content:\"\";left:50%;position:absolute;transform:translateX(-50%)}@media(max-width:985px){.staccato[data-v-116af266]:before{height:2px;top:-4px;width:2px}}@media(min-width:986px){.staccato[data-v-116af266]:before{height:6px;top:-6px;width:6px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
